import img from "../../assets/amex-dsnb.jpeg";
import {stateContext} from "../../App";
import { useContext } from "react";

function Confirm() {
    const {setShowModal} = useContext(stateContext);
    return (
        <>
            <div className="flex justify-center items-center md:w-full backdrop-blur-[1px] bg-black/40 overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="flex my-6 mx-auto  max-w-7xl ">
                    <div className="w-full rounded-lg p-8 xl:h-auto h-96 bg-white ">
                        <div className="flex xl:flex-row gap-10 h-full xl:overflow-hidden overflow-scroll flex-col p-2">
                        <div className="flex-grow">
                            <h1 className="text-xl text-zinc-800 font-bold mb-5">Payment Confirmation</h1>
                            <div className="red-color1 font-bold text-sm flex items-center justify-between mt-5">
                                <div>
                                    <p className="text-zinc-800 text-base">Card Number</p>
                                    <p className="text-zinc-400 font-medium text-xxs">Enter the 16-digit number of the card</p>
                                </div>
                                <p className="flex">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                    </svg>
                                    Edit
                                </p>
                            </div>
                            <Input placeholder="6543 - 2143 - 2157 - 2142" />
                            <div className="flex mt-5 gap-10 items-center justify-between">
                                <div>
                                    <p className="text-zinc-800 text-sm font-bold ">CVV Number</p>
                                    <p className="text-zinc-400 font-medium text-xxs">Enter the 3 to 4 digit number of the card</p>
                                </div>
                                <div className="flex shadow-lg border-0 p-3 items-center ">
                                    <input placeholder="723" className="pr-10 font-medium text-right" />
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="lightgray">
                                        <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="mt-5 mb-5 flex items-center justify-between">
                                <div>
                                    <p className="text-zinc-800 text-sm font-bold ">Expire Data</p>
                                    <p className="text-zinc-400 font-medium text-xxs">Enter expire data of card</p>
                                </div>
                                <div>
                                    <input className="shadow-lg border-0 outline-0 p-3 text-center text-zinc-900 font-medium w-16" type="text" placeholder="02" />
                                        <span className="ml-5 mr-5">/</span>
                                    <input className="shadow-lg border-0 outline-0 p-3 text-center text-zinc-900 font-medium w-16" type="text" placeholder="25" />
                                </div>
                            </div>
                            <div className="mt-5 mb-5 flex items-center justify-between">
                                <div>
                                    <p className="text-zinc-800 text-sm font-bold ">Password</p>
                                    <p className="text-zinc-400 font-medium text-xxs">Enter Your Dynamic password</p>
                                </div>
                                <div className="flex items-center shadow-lg">
                                    <input className=" border-0 outline-0 p-3 text-zinc-900 font-bold w-52" type="Password" placeholder="*********" />
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="lightgray">
                                        <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                    </svg>
                                </div>
                            </div>
                            <button onClick={() => setShowModal(7)} className="bg-red-700 w-full pt-2 pb-2 rounded-xl font-bold text-base text-white mt-3" >Pay Now</button>
                        </div>
                        <div>
                            <InstaBanner />
                        </div>
                      </div>
                    </div>
                    <div onClick={() => setShowModal(0)} className="flex justify-center items-center ml-3 rounded-full bg-white h-5 w-5">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </div>
                </div>
            </div>
        </>
    )
}

function InstaBanner() {
    return (
        <div className="col-span-1">
            <div style={{height: "95%"}} className="flex h-full flex-col justify-between">
                <div className="gray-color2 rounded-lg mt-5 p-5">
                    <h1 className="text-md gray-color1 font-bold">Banner On Instagram, App</h1>
                    <div className="text-xs font-bold text-zinc-400 flex items-center justify-between mt-3">
                        <p>Schedual Quantity</p>
                        <p>200000</p>
                    </div>
                    <div className="text-xs font-bold text-zinc-400 flex items-center justify-between mt-3">
                        <p>Date Scaduled</p>
                        <p>30 Apr</p>
                    </div>
                    <div className="text-xs font-bold text-zinc-400 flex items-center justify-between mt-3">
                        <p>Rate</p>
                        <p>₹ 15</p>
                    </div>
                    <div className="red-color1 font-bold text-sm flex items-center justify-between mt-5">
                        <div>
                            <p>Sub Total Inc.</p>
                            <p>taxes (18% GST)</p>
                        </div>
                        <p>₹ 3,40,000</p>
                    </div>
                    <div style={{borderTop: "1px solid rgba(128, 128, 128,0.3)"}} className="divider mt-4 mb-12"></div>
                    <div className="red-color1 font-bold text-sm flex items-center justify-between mt-5">
                        <p className="text-zinc-800">My Card</p>
                        <p className="flex">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                            </svg>
                            Edit
                        </p>
                    </div>
                    <img className="max-w-xs mx-auto mt-3" src={img} alt="a"/>
                </div>
            </div>
        </div>
    )
}

function Input({text, placeholder, children}) {
    return (
        <div>
            <h4 className="text-sm font-semibold">{text}</h4>
            <div className="p-3 mt-3 flex rounded-md w-full bg-gray-100">
                <input style={{width:"20%"}} className="flex-1 w-auto mr-3 bg-transparent font-medium" type="text" placeholder={placeholder} />
                {children}
            </div>
        </div>
    )
}

export default Confirm;